/**
 * src/api/webchatChannel.js
 */
import { getAuthHeaders } from './auth';
import { getBaseUrl as BASE } from './utils';
async function _parse(r) { const d = await r.json(); if (!r.ok) throw new Error(d?.message || d?.error || 'Request failed'); return d.status === 'success' && d.data ? d.data : (d.data ?? d); }

export const WEBCHAT_API_URL = `${BASE()}/bot/webchat`;

export function generateWidgetId(domain) {
  let h = 0; const s = `aerochat-${domain || 'default'}`;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return Math.abs(h).toString(16).padStart(32, '0').slice(0, 32);
}

export function copyWebchatEmbedCode(embedCode) {
  navigator.clipboard.writeText(embedCode || '').catch(console.error);
}

export async function fetchWebchatFromDb() {
  try {
    const data = await _parse(await fetch(`${BASE()}/bot/webchat/account`, { headers: { Accept: 'application/json', ...getAuthHeaders() } }));
    if (data?.widget_id) return { exists: true, row: { widget_id: data.widget_id, webpage: data.domain, embedded_instruction: data.embed_code, display_mode: data.display_mode || 'floating' } };
    return { exists: false };
  } catch { return { exists: false }; }
}

export async function saveWebchatDomain(domain) {
  try {
    const data = await _parse(await fetch(`${BASE()}/bot/webchat/save-domain`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', ...getAuthHeaders() }, body: JSON.stringify({ domain }) }));
    return { ok: true, embedCode: data.embed_code, widgetId: data.widget_id };
  } catch (err) { return { ok: false, message: err.message }; }
}

export async function upsertWebchatRow(widgetId, webpage) {
  return saveWebchatDomain(webpage || '');
}

export async function fetchInstallStatus() {
  try {
    const data = await _parse(await fetch(`${BASE()}/bot/webchat/install-status`, { headers: { Accept: 'application/json', ...getAuthHeaders() } }));
    return { installed: data.installed || false, domain: data.installed_domain || null, installedAt: data.installed_at || null };
  } catch { return { installed: false, domain: null, installedAt: null }; }
}
